import { EuiCard } from "@elastic/eui";
import React, { useEffect } from "react";
import LoginScreenContainer from "./container";

export const LoginScreen = () =>{
  
  return (
    <EuiCard className="cardLogin"><LoginScreenContainer/></EuiCard>
  )
}